import React from "react";

const SuccessScreen = () => {
  return (
    <div className="text-black h-[500px] flex flex-col items-center justify-center">
      <img
        src="/assets/money/success-icon.webp"
        alt="success"
        className="w-[200px]"
      />
      <div className="text-[28px] font-bold">
        Your form has been successfully submitted
      </div>
      <h4 className="w-[550px] text-center">
        Someone from team will contact you soon and take the process further. In
        the meanwhile explore money section more
      </h4>
    </div>
  );
};

export default SuccessScreen;
